import { useCallback, useState } from "react";
import queryString from 'query-string';

import useNotification from "./useNotification";
import useTranslations from "./useTranslations";
import { useGetCredential } from '../graphql/generated/definitions';

export type PDFConversionParams = {
  url: string,
  withCredentials: boolean,
  format?: "A4" | "letter",
  extraQueryParams?: {
    [key: string]: string | string[];
  }
  withErrorNotification?: boolean
}

function usePDFConversion() {
  const { data: { credential: viewerCredentials } } = useGetCredential();
  const [ loading, setLoading ] = useState(false);

  const { notifyError } = useNotification();
  const t = useTranslations();

  const convert = useCallback(async ({
    url,
    withCredentials = true,
    format = "A4",
    extraQueryParams = {},
    withErrorNotification = true
  }: PDFConversionParams) => {
    setLoading(true);

    try {
      const response = await fetch(
        queryString.stringifyUrl({
          url: `${document.querySelector('meta[name="rapaas-url"]')?.getAttribute('content')}/pdf`,
          query: {
            format,
            url: queryString.stringifyUrl({ url, query: withCredentials ? { ...extraQueryParams,  ...viewerCredentials } : extraQueryParams })
          }
        })
      )

      const blob = await response.blob();
      return (blob);

    } catch (e) {
      if (withErrorNotification) {
        notifyError({
          title: t(`pdfConversion.error`) as string,
        });
      }
      throw e;

    } finally {
      setLoading(false);
    }

  }, [viewerCredentials, notifyError]);

  return { convert, loading }
}

export default usePDFConversion;
